/**
 * Valida si un cliente tiene coordenadas válidas
 * @param {Object} cliente - El objeto cliente a validar
 * @returns {boolean} - true si el cliente tiene coordenadas válidas, false en caso contrario
 */
export const tieneCoordenadasValidas = (cliente) => {
  if (!cliente) return false;
  
  const lat = cliente.clt_lat;
  const lon = cliente.clt_lon;
  
  // Verificar que existan y no estén vacíos
  if (!lat || !lon || lat === '' || lon === '') {
    return false;
  }
  
  // Convertir a número y verificar que sean números válidos
  const latNum = parseFloat(lat);
  const lonNum = parseFloat(lon);
  
  if (isNaN(latNum) || isNaN(lonNum)) {
    return false;
  }
  
  // Verificar rangos válidos de latitud y longitud
  if (latNum < -90 || latNum > 90 || lonNum < -180 || lonNum > 180) {
    return false;
  }
  
  return true;
};

/**
 * Filtra un array de clientes para obtener solo aquellos con coordenadas válidas
 * @param {Array} clientes - Array de clientes a filtrar
 * @returns {Array} - Array de clientes con coordenadas válidas
 */
export const filtrarClientesConCoordenadas = (clientes) => {
  if (!Array.isArray(clientes)) return [];
  return clientes.filter(tieneCoordenadasValidas);
};

/**
 * Cuenta cuántos clientes tienen coordenadas válidas
 * @param {Array} clientes - Array de clientes a contar
 * @returns {number} - Número de clientes con coordenadas válidas
 */
export const contarClientesConCoordenadas = (clientes) => {
  if (!Array.isArray(clientes)) return 0;
  return clientes.filter(tieneCoordenadasValidas).length;
};
